import { render, staticRenderFns } from "./IncomingAlerts.vue?vue&type=template&id=04ccbd37&scoped=true&"
import script from "./IncomingAlerts.vue?vue&type=script&lang=js&"
export * from "./IncomingAlerts.vue?vue&type=script&lang=js&"
import style0 from "./IncomingAlerts.vue?vue&type=style&index=0&id=04ccbd37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ccbd37",
  null
  
)

export default component.exports